import React from "react";
import { useTranslation } from "react-i18next";
import useLangNavigate from "../common/useLangNavigate";
import { useLocalizedUrl } from "../common/useLocalizedUrl";
import FeatureCard from "../common/feature-card/FeatureCard";
import { svgs } from "../../core/constants/svgs";

const FinishedBookOptions = () => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const { getUrl } = useLocalizedUrl();

  const finishedBookOptions = [
    {
      key: "audiobook",
      name: t("finished_book.audiobook"),
      description: t("finished_book.audiobook_desc"),
      icon_key: "audiobook_icon",
      action: () => navigate("/audiobook-upload"),
    },
    {
      key: "print_book",
      name: t("finished_book.print_book"),
      description: t("finished_book.print_book_desc"),
      icon_key: "print_icon",
      action: () => navigate("/printing"),
    },
    {
      key: "meet_writer",
      name: t("finished_book.meet_writer"),
      description: t("finished_book.meet_writer_desc"),
      // icon_key: "clockTwoThirty",
      action: () => navigate("/proofreading-estimation"),
    },
    {
      key: "couverture_mise_en_page",
      name: t("finished_book.couverture_mise_en_page"),
      description: t("finished_book.couverture_mise_en_page_desc"),
      action: () => { window.location.href = getUrl("/contact/"); },
    },
    // {
    //   key: "publish_amazon",
    //   name: t("finished_book.publish_amazon"),
    //   description: t("finished_book.publish_amazon_desc"),
    //   icon_key: "publish_icon",
    //   action: () => navigate("/publishing"),
    // },
  ];

  return (
    <section className="aai-features py-100 finished-book-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="aai-section-title mb-5 text-center">
              <h2 className="section-title">{t("finished_book.main_title")}</h2>
              <p className="section-desc">{t("finished_book.main_subtitle")}</p>
            </div>
          </div>
        </div>

        {/* Options */}
        <div className="row">
          {finishedBookOptions.map((item, index) => {
            const icon =
              item.icon_key && svgs[item.icon_key] ? svgs[item.icon_key] : null;
            return (
              <FeatureCard
                key={`finished-option-${index}`}
                onClick={item.action}
                img={icon}
                name={item.name}
                description={item.description}
                showArrow={true}
                variant="finished-book"
                colClasses="col-lg-3 col-md-6"
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FinishedBookOptions;
